'use client';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import '../business.css';
import '../../job-board/JobBoard.css';
import { MdCall, MdContentCopy, MdOpenInNew, MdShare } from 'react-icons/md';
// import ThreeDotMenu from './ThreeDotMenu';

function normalize(input) {
  if (!input) return "";

  try {
    if (Array.isArray(input)) {
      if (input.length === 1 && typeof input[0] === "string" && input[0].trim().startsWith("[")) {
        const arr = JSON.parse(input[0]);
        return arr.join(", ");
      }
      return input.join(", ");
    }

    if (typeof input === "string" && input.trim().startsWith("[")) {
      const arr = JSON.parse(input);
      return Array.isArray(arr) ? arr.join(", ") : input;
    }

    return input.toString();
  } catch (e) {
    return input.toString();
  }
}

function shortenURL(url) {
  try {
    const finalUrl = new URL(url);
    let host = finalUrl.host.replace(/^www\./, "");
    return host;
  } catch (err) {
    return url;
  }
}

export default function BusinessCard({
  company,
  category,
  description,
  location,
  logo,
  website_url,
  contact,
  mail,
  isSponsored = false,
  source_record_id
}) {

  const handleShare = useCallback(() => {
    const baseUrl = window.location.origin + window.location.pathname;

    const shareUrl = `${baseUrl}?business=${encodeURIComponent(
      source_record_id
    )}`;

    navigator.clipboard.writeText(shareUrl)
      .then(() => toast.success("Share link copied!"))
      .catch(() => toast.error("Failed to copy link"));
  }, [source_record_id]);

  const handleCopy = useCallback((text, fieldName) => {
    if (navigator.clipboard && text) {
      navigator.clipboard.writeText(text).then(() => {
        toast.success(`${fieldName} copied!`);
      }).catch(err => {
        toast.error(`Failed to copy ${fieldName}.`);
      });
    }
  }, []);

  const openMap = useCallback((address) => {
    if (!address) return;

    const encodedAddress = encodeURIComponent(address);
    const url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  const displayCategory = normalize(category);
  const displayDescription = normalize(description);

  return (
    <div
      className={`job-card BusinessCard ${isSponsored ? "sponsored-card" : ""}`}
      id={`${isSponsored ? "BusinessCard-sponsored" : "business-${source_record_id}"}`}

    >
      {isSponsored && (
        <div className="sponsored-badge">SPONSORED</div>
      )}
      <div className="Business">

        <img className="company-logo"
          src={logo || "/images/Job/image.png"}
          alt={`${company} logo`}
        />

        <div className="job-info">
          <div className="flexBusinessinfo">
            <h4 className="Helping-users-travel">{company}</h4>

            <div className="flexBusinessinfo" id='flexinfoshare'>
              {displayCategory && (
                <div className="Frame-260">
                  <span className="businesstype">
                    {displayCategory}
                  </span>
                </div>
              )}
              {/* <ThreeDotMenu onShare={handleShare} /> */}
            </div>
          </div>
          {displayDescription && (
            <p className="job-description" id="business_decs">{displayDescription}</p>
          )}

          <span
            className="location clickable-location"
            id='businessLocation'
            role="button"
            onClick={() => openMap(location || "Munich")}
          >
            <span className="locationIcon">
              <img src='/images/Job/location_on1.svg' alt="Location Icon" />
            </span>
            {location || "Munich"}
          </span>

          <div className="contactDetails">

            {contact && (
              <button
                type="button"
                className="buttonprimarylarge"
                id="mailBtn"
                onClick={() => window.location.href = `tel:${contact}`}
              >
                <MdCall />

                <span className="truncate">{contact}</span>

                <span
                  className="copy-icon-container"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(contact, 'Phone');
                  }}
                >
                  <MdContentCopy />
                </span>
              </button>
            )}

            {mail && (
              <button
                type="button"
                className="buttonprimarylarge"
                id="mailBtn"
                onClick={() => window.location.href = `mailto:${mail}`}
              >
                <img src="/images/Business/mail.svg" alt="mail" />

                <span className="truncate">{mail}</span>

                <span
                  className="copy-icon-container"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(mail, 'Email');
                  }}
                >
                  <MdContentCopy />
                </span>
              </button>
            )}

            {website_url && (
              <button
                type="button"
                className="buttonprimarylarge"
                id="linkBtn"
                onClick={() =>
                  window.open(website_url, "_blank", "noopener,noreferrer")
                }
              >
                <img src="/images/Business/link.svg" alt="link" />

                <span className="truncate">{shortenURL(website_url)}</span>

                <MdOpenInNew />
              </button>
            )}

          </div>

        </div>
      </div>
    </div>
  );
}